import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { GridItem } from '@progress/kendo-angular-grid';
import { GridColumn } from '../../models/grid-definition.model';
import { CellClickEvent } from '../../models/grid-events.model';
import { DecimalPipe } from '@angular/common';
import { HyperlinkDirective } from '../../../hyperlink/hyperlink.directive';
import { ProgressBarComponent } from '../../../ui-components/components/progress-bar/progress-bar.component';
import { OptionSetProgressBarComponent } from '../../../ui-components/components/optionset-progress-bar/optionset-progress-bar.component';
import { RatingComponent } from '../../../ui-components/components/rating/rating.component';
import { ImgIconComponent } from '../../../ui-components/components/img-icon/img-icon.component';
import { EngineProcessGridCellComponent } from '../../../../core/engine-processes/components/engine-process-grid-cell.component/engine-process-grid-cell.component';
import { MaskPipe } from '../../../utils/pipes/mask.pipe';
import { DateTimePipe } from '../../pipes/date-time.pipe';
import { OptionSetPipe } from '../../pipes/optionSet.pipe';
import { OptionSetColorPipe } from '../../pipes/option-set-color.pipe';
import { TimePipe } from '../../pipes/time.pipe';
import { RatingOptionsPipe } from '../../pipes/rating-options.pipe';
import { OptionSetValuePipe } from '../../pipes/option-set-value.pipe';
import { IconPipe } from '../../pipes/icon.pipe';
import { IconUrlPipe } from '../../pipes/icon-url.pipe';
import { IconTitlePipe } from '../../pipes/icon-title.pipe';
import { CombinedTextsPipe } from '../../pipes/combined-texts.pipe';
import { LookupPipe } from '../../pipes/lookup.pipe';
import { HyperlinkPipe } from '../../pipes/hyperlink.pipe';

@Component({
    selector: 'app-grid-column-cell',
    templateUrl: './grid-column-cell.component.html',
    styleUrls: ['./grid-column-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        HyperlinkDirective,
        ProgressBarComponent,
        OptionSetProgressBarComponent,
        RatingComponent,
        ImgIconComponent,
        EngineProcessGridCellComponent,
        DecimalPipe,
        MaskPipe,
        DateTimePipe,
        OptionSetPipe,
        OptionSetColorPipe,
        TimePipe,
        RatingOptionsPipe,
        OptionSetValuePipe,
        IconPipe,
        IconUrlPipe,
        IconTitlePipe,
        CombinedTextsPipe,
        LookupPipe,
        HyperlinkPipe,
    ]
})
export class GridColumnCellComponent {
  readonly column = input<GridColumn>(undefined);
  readonly dataItem = input<GridItem>(undefined);

  readonly cellClick = output<CellClickEvent>();

  emitCellClick(event: Event, fieldName?: string) {
    const column = this.column();
    if (column.isClickable) {
      event.stopImmediatePropagation();
      this.cellClick.emit({
        column: column,
        dataItem: this.dataItem(),
        fieldName: fieldName ?? column.primaryField,
      });
    }
  }

  getNumberFormat() {
    const column = this.column();
    if (column.decimalPlaces) {
      return `1.${column.decimalPlaces}-${column.decimalPlaces}`;
    }

    return `1.2-2`;
  }
}
